// extracted by mini-css-extract-plugin
module.exports = {"root":"Region_root__34yIT","clickable":"Region_clickable__F9Rfn","highlighted":"Region_highlighted__3YAQH"};